//@ts-ignore
import AuthGuard from "shared/components/AuthGuard";
import { Suspense, Fragment } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "shared/components/Loader";
import { useAppInstanceConst } from "contexts/AppInstanceProvider";

const renderRoute = ({ component: Component, ...route }: any) => {
  const { Layout, useAuth } = route;
  const routeContent = (
    <Suspense fallback={<Loader />}>
      {useAuth ? (
        <AuthGuard>
          <Component />
        </AuthGuard>
      ) : (
        <Component />
      )}
    </Suspense>
  );

  return (
    <Route
      key={route.path}
      path={route.path}
      element={
        Layout ? (
          <Suspense fallback={<Loader />}>
            <Layout
              sidebarLinks={route.sidenavItems || []}
              isSuperAdmin={route.isSuperAdmin || false}
            >
              {routeContent}
            </Layout>
          </Suspense>
        ) : (
          <Fragment>{routeContent}</Fragment>
        )
      }
    />
  );
};

export const RoutesWrapper = () => {
  const { BaseRoutes } = useAppInstanceConst();
  return <Routes>{BaseRoutes.map((route) => renderRoute(route))}</Routes>;
};
